module.exports = __webpack_public_path__ + "static/img/web_logo.0538ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_logo.png
// module id = CTkG
// module chunks = 1